export enum OrchestrationDiagramParts {
  DefaultNode = 'DefaultNode',
  MainPanel = 'MainPanel',
  ContentPanel = 'ContentPanel',
  ImportTypeButton = 'ImportTypeButton',
  OnFailureButton = 'OnFailureButton',
  ShowLogsButton = 'ShowLogsButton',
  RedirectButton = 'RedirectButton',
}
